import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';

interface ConfettiEffectProps {
  trigger: boolean;
  duration?: number;
  particleCount?: number;
  spread?: number;
  colors?: string[];
}

const ConfettiEffect: React.FC<ConfettiEffectProps> = ({
  trigger,
  duration = 3000,
  particleCount = 100,
  spread = 70,
  colors = ['#26a69a', '#00897b', '#00796b', '#00695c', '#004d40']
}) => {
  const [canvasRef, setCanvasRef] = useState<HTMLCanvasElement | null>(null);
  
  useEffect(() => {
    // Criar elemento canvas para o confetti
    const canvas = document.createElement('canvas');
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '9999';
    
    // Adicionar ao DOM
    document.body.appendChild(canvas);
    setCanvasRef(canvas);
    
    // Limpar ao desmontar
    return () => {
      document.body.removeChild(canvas);
    };
  }, []);
  
  useEffect(() => {
    if (!trigger || !canvasRef) return;
    
    // Configurar o confetti
    const myConfetti = confetti.create(canvasRef, {
      resize: true,
      useWorker: true
    });
    
    // Lançar confetti
    const end = Date.now() + duration;
    
    const frame = () => {
      myConfetti({
        particleCount: particleCount / 10,
        angle: 60,
        spread,
        origin: { x: 0, y: 0.8 },
        colors
      });
      
      myConfetti({
        particleCount: particleCount / 10,
        angle: 120,
        spread,
        origin: { x: 1, y: 0.8 },
        colors
      });
      
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };
    
    frame();
    
    // Limpar após a duração
    const timeout = setTimeout(() => {
      myConfetti.reset();
    }, duration);
    
    return () => clearTimeout(timeout);
  }, [trigger, canvasRef, duration, particleCount, spread, colors]);
  
  return null; // Este componente não renderiza nada visível diretamente
};

export default ConfettiEffect; 